<template>
  <baidu-map
    ak="ixaoNPBR6nP4VvmGamrvFyTe2FZZF42l"
    class="map"
    ref="map"
    :center="center"
    v-if="center.lng"
    :zoom="zoom"
    @ready="handler"
    :scroll-wheel-zoom="true"
  >
    <bml-marker-clusterer :averageCenter="true">
      <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
      <!--聚合动态添加的点坐标-->
      <bm-marker
        v-for="(marker, index) in markers"
        :key="index"
        :position="{ lng: marker.lng, lat: marker.lat }"
        @click="lookDetail(marker)"
      ></bm-marker>
      <!--信息窗体-->
      <bm-info-window
        :position="{
          lng: infoWindow.info.lng,
          lat: infoWindow.info.lat
        }"
        :title="infoWindow.info.name"
        :show="infoWindow.show"
        @close="infoWindowClose"
        @open="infoWindowOpen"
      >
        <div>
          <h3>{{ addr }}</h3>
          <h4>当前经纬度：</h4>
          <div>经度：{{ infoWindow.info.lng }}</div>
          <div>纬度：{{ infoWindow.info.lat }}</div>
        </div>
      </bm-info-window>
    </bml-marker-clusterer>
  </baidu-map>
</template>

<script>
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import { BmlMarkerClusterer, BmNavigation, BmMarker, BmInfoWindow } from 'vue-baidu-map'
export default {
  components: {
    BaiduMap,
    BmNavigation,
    BmlMarkerClusterer,
    BmMarker,
    BmInfoWindow
  },
  props: {
    ln: {
      type: String
    },
    la: {
      type: String
    },
    addr: {
      type: String
    }
  },
  data() {
    return {
      center: {},
      zoom: 18,
      infoWindow: {
        info: {},
        show: false
      },
      markers: []
    }
  },
  mounted() {
    this.center = {
      lng: this.ln,
      lat: this.la
    }
    this.markers = [
      {
        name: '地理位置',
        lng: this.ln,
        lat: this.la,
        show: false
      }
    ]
  },
  methods: {
    handler() {
      // var map = new BMap.Map(this.$refs.map);
    },
    //查看详情
    lookDetail(data) {
      this.infoWindow.show = true
      this.infoWindow.info = data
    },
    infoWindowClose(e) {
      this.infoWindow.show = false
    },
    infoWindowOpen(e) {
      this.infoWindow.show = true
    }
  }
}
</script>
<style lang="scss" scoped>
.map {
  margin-top: 2px;
  width: 100%;
  height: 360px;
}
</style>
